import { IEnvironment } from './Ienvironment';

export const environment: IEnvironment = {
	production: true,
	hmr: false,
	api: {
		uri: '',
	},
	realtime: {
		host: '',
		port: 443,
	},
	matomo: {
		enabled: true,
		url: '//analytics.visibacare.com/',
		siteId: 4,
	},
	serverBaseUrl: '/PublicV3',
	cdn: {
		customer: '//customer-cdn.visibacare.com',
		media: '//media-cdn.visibacare.com',
	},
};
